const SPLIT_PAID_TO_SUFFIX = ' (Split)';

/**
 * Resolves the base deposit account label before optional split suffix.
 * @param {Object} rowData
 * @returns {string}
 */
const getDepositAccountBaseLabel = (rowData) => rowData?.deposit_account_name || rowData?.deposit_display_label || '-';

/**
 * Formats the Paid To column label for a payment history row.
 * @param {Object} rowData
 * @returns {string}
 */
export const formatPaymentHistoryPaidToLabel = (rowData) => {
  if (rowData?.is_split === true && rowData?.deposit_into === 'operating') {
    return `${getDepositAccountBaseLabel(rowData)}${SPLIT_PAID_TO_SUFFIX}`;
  }

  return rowData?.deposit_account_name || '-';
};
